var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.timeClocks},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(_vm.$moment(item.created_at).format('D MMMM YYYY'))+"\n        ")]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }